import { useClientTerminology } from '@/views/list/NetworkTerms';
import { RiskRating } from '@/components';
import { Rating } from '@/features/types';
import { getRatingId } from '@/helpers/encroachmentRating';

export const EncroachmentRiskRating = ({
  rating,
  score,
  variant = 'primary',
  'data-testid': testId,
}: {
  rating: Rating;
  score: number;
  variant?: 'primary' | 'secondary';
  'data-testid'?: string;
}) => {
  const intl = useClientTerminology();
  const { formatMessage } = useClientTerminology();

  // Only valid for spans
  const numValidRatings = Object.keys(Rating).length / 2 - 1;
  const validRating = rating > numValidRatings ? Rating.Unknown : rating;

  const ratingLabel = formatMessage({
    id: getRatingId(validRating),
  });

  const scoreLabel =
    score === 0
      ? 0
      : intl.formatNumber(score, {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        });

  const label =
    score !== -1 && validRating !== Rating.Unknown
      ? `${ratingLabel} (${scoreLabel})`
      : 'Unknown';

  return (
    <RiskRating
      rating={validRating}
      label={label}
      variant={variant}
      data-testid={testId}
    />
  );
};
